import { render, staticRenderFns } from "./BusinessPartnerForm.vue?vue&type=template&id=21579ec4&"
import script from "./BusinessPartnerForm.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerForm.vue?vue&type=style&index=0&id=21579ec4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports